import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { cn } from "@/lib/utils";

interface ReferenceIdBadgeProps {
  id: string;
  className?: string;
}

export function ReferenceIdBadge({ id, className }: ReferenceIdBadgeProps) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-0.5 font-mono text-xs text-muted-foreground",
        className,
      )}
      style={{ background: "hsl(210,16%,93%)" }}
    >
      {id}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          handleCopy();
        }}
        className="text-muted-foreground hover:text-foreground"
        title="Copy reference ID"
      >
        {copied ? (
          <Check className="h-3 w-3 text-green-600" strokeWidth={1.5} />
        ) : (
          <Copy className="h-3 w-3" strokeWidth={1.5} />
        )}
      </button>
    </span>
  );
}
